import { isEmpty } from 'lodash';

export const pxToPercentage = (value = 0, axis, parent) => {
  if (axis === 'x') {
    return (value / parent.offsetWidth) * 100;
  } else if (axis === 'y') {
    return (value / parent.offsetHeight) * 100;
  }
  console.error('Wrong axis param');
  return 0;
};

export const percentageToPx = (value = 0, axis, parentWidth, parentHeight) => {
  if (axis === 'x') {
    return Math.round((value * parentWidth) / 100);
  } else if (axis === 'y') {
    return Math.round((value * parentHeight) / 100);
  }
  console.error('Wrong axis param');
  return 0;
};

const getFullSize = () => {
  const el = document.getElementById('full-size-sketch');
  const mmToPx = 3.7795275591;
  if (el) {
    return { width: el.offsetWidth / mmToPx, height: el.offsetHeight / mmToPx };
  }
  return {};
};

export const getMMValue = (percentValue, axis) => {
  if (!percentValue) {
    return;
  }
  const fullSize = getFullSize();
  if (axis === 'x') {
    return `${((percentValue / 100) * fullSize.width).toFixed(2)}mm`;
  }
  return `${((percentValue / 100) * fullSize.height).toFixed(2)}mm`;
};

export const getPercentageValue = value => (value ? `(${Number(value).toFixed(2)}%)` : '');

export const getMMValueWithInverted = (markingImg, isInverted, axis) => {
  if (!markingImg || isEmpty(markingImg?.position)) {
    return '0mm';
  }

  const fullSize = getFullSize();

  const marking = {
    positionX: (markingImg.position?.x || 0) / 100,
    positionY: (markingImg.position?.y || 0) / 100,
    width: (markingImg.width || 0) / 100,
    height: (markingImg.height || 0) / 100,
  };

  const invertedX = isInverted ? (marking.width * fullSize.width) / 2 - (marking.height * fullSize.height) / 2 : 0;
  const invertedY = isInverted ? (marking.height * fullSize.height) / 2 - (marking.width * fullSize.width) / 2 : 0;

  let position = 0;

  if (axis === 'x') {
    position = marking.positionX * fullSize.width;
    position += invertedX;
  } else if (axis === 'y') {
    position = marking.positionY * fullSize.height;
    position += invertedY;
  } else if (axis === '-x') {
    position = (1 - marking.width - marking.positionX) * fullSize.width;
    position += invertedX;
  } else if (axis === '-y') {
    position = (1 - marking.height - marking.positionY) * fullSize.height;
    position += invertedY;
  } else {
    console.error('Wrong axis param');
    return '0mm';
  }
  return `${Math.round(position)}mm`;
};
